import React from "react";
import CustomButton from "../CustomButton";
import Fontstyling from "../comman";

const DeleteModal = ({ onClickYes, onClickNo }) => {
  return (
    <>
      <div className="text-nowrap">
        Are you sure that you want to delete the record?
      </div>
      <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
        <button style={Fontstyling.savebutton} onClick={onClickYes}>
          Yes
        </button>
        <button style={Fontstyling.cancelbutton} onClick={onClickNo}>
          No
        </button>
      </div>
    </>
  );
};

export default DeleteModal;
